import { z } from 'zod';
/**
 * Fattura da emettere — schemi condivisi F-011 (rescoped 2026-07-08).
 *
 * Coda "fatture da emettere" alimentata dai pagamenti Stripe riusciti
 * (ricarica wallet F-009.2 e pay-per-practice F-010). Niente SDI in V1: le
 * fatture si emettono manualmente dal gestionale esterno — questi schemi
 * coprono solo la vista admin (elenco + segna-fatturata) e il body di
 * quest'ultima azione.
 *
 * Pattern (cfr. fido.ts / operator.ts): tuple `as const` + `z.enum(...)`,
 * `.strict()` sui body/query.
 */
/* -------------------------------------------------------------------------- */
/* Tipo / Stato — mirror degli enum Prisma `FatturaTipo` / `FatturaDaEmettereStato` */
/* -------------------------------------------------------------------------- */
export const FATTURA_TIPI = ['RICARICA_WALLET', 'PAGAMENTO_PRATICA'];
export const fatturaTipoEnum = z.enum(FATTURA_TIPI);
export const FATTURA_TIPO_LABELS = {
    RICARICA_WALLET: 'Ricarica wallet',
    PAGAMENTO_PRATICA: 'Pagamento pratica',
};
export const FATTURA_STATI = ['DA_FATTURARE', 'FATTURATA'];
export const fatturaStatoEnum = z.enum(FATTURA_STATI);
export const FATTURA_STATO_LABELS = {
    DA_FATTURARE: 'Da fatturare',
    FATTURATA: 'Fatturata',
};
/* -------------------------------------------------------------------------- */
/* listFattureQuerySchema — query di GET /api/v1/admin/fatture               */
/* -------------------------------------------------------------------------- */
export const listFattureQuerySchema = z
    .object({
    stato: fatturaStatoEnum.optional(),
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
})
    .strict();
/* -------------------------------------------------------------------------- */
/* markFatturataInputSchema — body di PATCH /api/v1/admin/fatture/:id        */
/* -------------------------------------------------------------------------- */
export const markFatturataInputSchema = z
    .object({
    numeroFattura: z.string().trim().min(1, 'Numero fattura vuoto').max(100).optional(),
})
    .strict();
//# sourceMappingURL=fattura.js.map